import { Component } from '@angular/core';

import { ApiService } from '@app/shared/services/api.service';
import { Product } from '../../../../shared/interfaces/product';
import { RequestModel } from '../../../../shared/interfaces/RequestModel';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-header-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent {
    constructor(
        private apiServices: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        public storeService: StoreService
    ) {

        alert();
    }

    products: Product[]; // old was { = products } // extend
    requestModel: RequestModel;
    keyword: string;
    productId: number;

    searchForm = new FormGroup({
        keyword: new FormControl('')
    });

    onSubmit() {
        alert(this.productId);
        this.router.navigate(['/product/' + this.productId]);
    }

    ProductSelected(event: any): void {
        console.log('Productselected' + event.target.value);
        this.router.navigate(['/product/' + this.keyword]);
    }

    changeSelected(event): void {
        this.productId = event.target.value;
    }

    SearchChanged(value: string): void {
        // console.log(value);
        this.keyword = value;
        if (value.length > 1) {
            // init requestmodel
            this.requestModel = {
                TotalPages: 1,
                PageSize: 50,
                CurrentPage: 1,
                Sort: 'NameA',
                Params:
                {
                    CategoryID: 0,
                    InStock: false,
                    readySend: false,
                    Pricing: null,
                    Attribute: null,
                    query: value
                }
            };

            this.apiServices.getProductsBy(this.requestModel).subscribe(x => {
                this.products = x['data'].result as Product[];
                console.log(this.products);
                // this.requestModel.TotalPages = x["Data"]["Result"].Total as number;
            });
        } else {
            this.products = [];
        }
    }
}
